import React from 'react'
import { useSelector } from 'react-redux'
import { useDrivingDistanceFromLatestLocationQuery } from 'apps/marketplace/pages/shipment-details/components/MapThumbnail/graphql/DrivingDistanceFromLatestLocation'
import { useGeocodeLocationQuery } from 'apps/marketplace/pages/shipment-details/components/MapThumbnail/graphql/GeocodeLocation'
import {
  selectUserProfileDetails,
  selectUserDriverLocations,
  selectLastKnownLocationShipment,
  selectNextStop,
} from 'apps/user/utils/selectors/userProfile'
import { Locations } from 'components/Locations'

export function LastLocation() {
  const userProfileDetails = useSelector(selectUserProfileDetails)
  const driverLocations = useSelector(selectUserDriverLocations)
  const recentLocationShipment = useSelector(selectLastKnownLocationShipment)
  const { id: recentShipmentId } = recentLocationShipment || {}
  const nextStop = useSelector(selectNextStop)

  const {
    data: drivingDistanceData,
    error: drivingDistanceError,
    loading: isLoadingDrivingDistance,
  } = useDrivingDistanceFromLatestLocationQuery({
    variables: {
      shipmentId: recentShipmentId || '',
      to: {
        latitude: Number(nextStop?.latitude),
        longitude: Number(nextStop?.longitude),
      },
    },
    skip: !nextStop,
  })
  const { drivingDistanceFromLatestLocation } = drivingDistanceData || {}
  const drivingDistance = !drivingDistanceError
    ? Number(drivingDistanceFromLatestLocation?.miles || 0)
    : undefined

  const { data: locationFeatures, loading: isLoadingGeocode } = useGeocodeLocationQuery({
    variables: {
      latitude: Number(nextStop?.latitude),
      longitude: Number(nextStop?.longitude),
    },
    skip: !nextStop,
  })
  const { geocodingSearch } = locationFeatures || {}
  const shipmentStops = [
    ...(recentLocationShipment?.pickups || []),
    ...(recentLocationShipment?.deliveries || []),
  ]
  return (
    <Locations
      userProfileDetails={userProfileDetails}
      driverLocations={driverLocations}
      features={geocodingSearch || []}
      isFetching={isLoadingDrivingDistance && isLoadingGeocode}
      finalStopDistanceMiles={drivingDistance}
      shipmentStatus={recentLocationShipment?.status.key || ''}
      nextStop={nextStop}
      stops={shipmentStops}
      trackingRequired={recentLocationShipment?.info.trackingRequired}
      trackingStatus={recentLocationShipment?.trackingStatus}
      shipperTrackingSegment={recentLocationShipment?.shipperTrackingSegment}
    />
  )
}
